import { REQUEST_POST_FORGOT_PASSWORD, RECEIVE_POST_FORGOT_PASSWORD } from "../types/forgotPassword/forgotPassword";

export const requestPostForgotPassword = data => ({
	type: REQUEST_POST_FORGOT_PASSWORD, data
});

export const receivePostForgotPassword = data => ({
	type: RECEIVE_POST_FORGOT_PASSWORD, data
});